import { Path, Svg } from '@react-pdf/renderer';

export const BirthDayIcon = ({ color }: { color: string }) => {
  return (
    <Svg width="16px" height="16px" viewBox="0 0 512 512" style={{marginTop: '4px', marginBottom: '4px'}}>
      <Path
        fill={color}
        d="M448 384c-28 0-31-32-74.5-32S326.7 384 299 384s-31.5-32-74.8-32-47.2 32-74.5 32-31.2-32-74.8-32S28.6 384 0 384v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zM96 96c-17.7 0-32-14.3-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.3 40-32 40zm128 0c-17.7 0-32-14.3-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.3 40-32 40zm128 0c-17.7 0-32-14.3-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.3 40-32 40z"
      />
    </Svg>
  );
};
